export default __webpack_public_path__ + "static/media/anwork-logo.6e5bb2dd.svg";